import * as React from "react";
import { forwardRef } from "react";
const SvgCrown = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 32, viewBox: "0 0 32 32", width: 32, xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "m6.66667 21.334-2.66667-14.66668 7.3333 6.66668 4.6667-8.00002 4.6667 8.00002 7.3333-6.66668-2.6667 14.66668zm18.66663 4c0 .8-.5333 1.3333-1.3333 1.3333h-16c-.8 0-1.33333-.5333-1.33333-1.3333v-1.3333h18.66663z", fill: "#eeebf4" }));
const ForwardRef = forwardRef(SvgCrown);
export default ForwardRef;
